import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import API from '../api';

export default function AdminPanel() {
  const [quizzes, setQuizzes] = useState([]);
  const [viewResults, setViewResults] = useState({});

  const thStyle = { padding: '8px 12px', textAlign: 'left', fontWeight: 700, fontSize: 12, letterSpacing: '.4px' };
  const tdStyle = { padding: '8px 12px', borderBottom: '1px solid #eee', fontSize: 13 };

  useEffect(() => {
    fetchQuizzes();
  }, []);

  const fetchQuizzes = async () => {
    const res = await API.get('/quizzes/admin');
    const quizzesData = res.data;

    // Get attempt counts
    const attemptsRes = await API.get('/attempts/all')
      .then(res => res.data)
      .catch(() => ({}));

    const enhanced = quizzesData.map(quiz => {
      let attemptCount = 0;
      Object.values(attemptsRes).forEach(userAttempts => {
        if (userAttempts[quiz.id]) attemptCount++;
      });
      return { ...quiz, attemptCount };
    });

    setQuizzes(enhanced);
  };

  const toggleActive = async (quiz) => {
    const res = await API.put(`/quizzes/${quiz.id}`, { active: !quiz.active });
    setQuizzes(quizzes.map(q => q.id === quiz.id ? { ...res.data, attemptCount: quiz.attemptCount } : q));
  };

  const deleteQuiz = async (id) => {
    if (!window.confirm('Delete this quiz permanently?')) return;
    await API.delete(`/quizzes/${id}`);
    setQuizzes(quizzes.filter(q => q.id !== id));
  };

  const downloadResults = (quizId, quizTitle) => {
    API.get(`/quizzes/${quizId}/results`, { responseType: 'blob' })
    .then(res => res.data)
    .then(blob => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${quizTitle.replace(/[^a-z0-9]/gi, '_')}_Results.xlsx`;
      a.click();
      a.remove();
    })
    .catch(() => alert('No results yet'));
  };

  const toggleViewResults = async (quizId) => {
    if (viewResults[quizId]?.visible) {
      setViewResults(prev => ({ ...prev, [quizId]: { ...prev[quizId], visible: false } }));
      return;
    }
    if (viewResults[quizId]?.data) {
      setViewResults(prev => ({ ...prev, [quizId]: { ...prev[quizId], visible: true } }));
      return;
    }
    setViewResults(prev => ({ ...prev, [quizId]: { loading: true, visible: true, data: null } }));
    try {
      const res = await API.get(`/quizzes/${quizId}/results-json`);
      const data = res.data;
      setViewResults(prev => ({ ...prev, [quizId]: { loading: false, visible: true, data } }));
    } catch {
      setViewResults(prev => ({ ...prev, [quizId]: { loading: false, visible: true, data: [] } }));
    }
  };

  return (
<>
  {/* AMAZON SELLER CENTRAL TOP BAR */}
  <div className="asc-topbar">
  <div className="asc-topbar-inner">

    {/* LEFT BLOCK */}
    <div className="asc-topbar-left">
      <img
        src="/scaling_white_background.png"
        alt="Amazon Seller Central"
        className="logo"
      />

        <span
          style={{
            background: '#fff',
            color: '#0f2a2e',
            fontSize: 12,
            padding: '3px 8px',
            borderRadius: 2,
            fontWeight: 600
          }}
        >
          ADMIN | IN
        </span>
    </div>

    {/* RIGHT BLOCK */}
    <div className="asc-topbar-right">
      <span>EN</span>
              <span
          style={{ cursor: 'pointer' }}
          onClick={() =>
            window.location.href =
              'https://sellercentral.amazon.in/help/hub/reference/external/login-help'
          }
        >
          Help
        </span>
              <button
          className="logout-btn"
          onClick={() => {
            localStorage.clear();
            window.location.href = '/Admin';
          }}
        >
          Logout
        </button>
    </div>

  </div>
</div>


  {/* PAGE */}
  <div className="asc-page">

    {/* SNAPSHOT */}
    <div className="asc-card">
      <div className="asc-card-body">
        <div className="asc-snapshot">
          <div>
            <div className="asc-snap-title">Total Quizzes</div>
            <div className="asc-snap-value">{quizzes.length}</div>
          </div>
          <div>
            <div className="asc-snap-title">Active Quizzes</div>
            <div className="asc-snap-value">
              {quizzes.filter(q => q.active !== false).length}
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* CREATE QUIZ ACTION */}
<div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
  <Link
    to="/create-quiz"
    className="asc-btn"
    style={{ textDecoration: 'none' }}
  >
    + Create New Quiz
  </Link>
</div>

    {/* QUIZ LIST */}
    {quizzes.length === 0 ? (
      <div className="asc-card">
        <div className="asc-card-body">
          No quizzes yet. Click “Create New Quiz” to get started.
        </div>
      </div>
    ) : (
      quizzes.map(quiz => (
        <div key={quiz.id} className="asc-card">
          <div className="asc-card-header">{quiz.title}</div>

          <div className="asc-card-body">
            <div style={{ fontSize: 13, marginBottom: 6 }}>
              {quiz.questions.length} Questions
            </div>

            <div style={{ marginBottom: 8 }}>
              <span
                style={{
                  color: quiz.active !== false ? '#067d62' : '#777',
                  fontWeight: 600
                }}
              >
                {quiz.active !== false ? '✓ Active' : '✗ Inactive'}
              </span>
            </div>

            <div style={{ marginBottom: 10 }}>
              Seller Attempted:{' '}
              <strong>{quiz.attemptCount}</strong>
            </div>

            {/* ACTIONS */}
            <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
              <Link
                to={`/create-quiz/${quiz.id}`}
                className="asc-btn"
                style={{ textDecoration: 'none' }}
              >
                Edit
              </Link>

              <button
                className="asc-btn"
                onClick={() => toggleActive(quiz)}
              >
                {quiz.active !== false ? 'Deactivate' : 'Activate'}
              </button>

              <button
                className="asc-btn"
                onClick={() => downloadResults(quiz.id, quiz.title)}
              >
                Export as Excel
              </button>

              <button
                className="asc-btn"
                style={{ background: viewResults[quiz.id]?.visible ? '#555' : '#0F2A2E' }}
                onClick={() => toggleViewResults(quiz.id)}
              >
                {viewResults[quiz.id]?.visible ? 'Hide Results' : 'View Results'}
              </button>

              <button
                className="asc-btn"
                style={{ background: '#b12704' }}
                onClick={() => deleteQuiz(quiz.id)}
              >
                Delete
              </button>
            </div>

            {/* INLINE RESULTS VIEWER */}
            {viewResults[quiz.id]?.visible && (
              <div style={{ marginTop: 20, borderTop: '1px solid #ddd', paddingTop: 16 }}>
                <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 12 }}>Results — {quiz.title}</div>
                {viewResults[quiz.id]?.loading ? (
                  <div style={{ color: '#888', fontSize: 13 }}>Loading…</div>
                ) : !viewResults[quiz.id]?.data?.length ? (
                  <div style={{ color: '#888', fontSize: 13 }}>No attempts recorded yet.</div>
                ) : (
                  <div style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                      <thead>
                        <tr style={{ background: '#232F3E', color: '#fff' }}>
                          <th style={thStyle}>MCID / Username</th>
                          <th style={thStyle}>Type</th>
                          <th style={thStyle}>Attempt #</th>
                          <th style={thStyle}>Score (%)</th>
                          <th style={thStyle}>Status</th>
                          <th style={thStyle}>Date</th>
                          <th style={thStyle}>Time</th>
                        </tr>
                      </thead>
                      <tbody>
                        {viewResults[quiz.id].data.map((row, idx) => (
                          <tr key={idx} style={{ background: idx % 2 === 0 ? '#f9f9f9' : '#fff' }}>
                            <td style={tdStyle}>{row.userId}</td>
                            <td style={tdStyle}>{row.type}</td>
                            <td style={{ ...tdStyle, textAlign: 'center' }}>{row.attemptNumber}</td>
                            <td style={{ ...tdStyle, textAlign: 'center', fontWeight: 700 }}>{row.score ?? '—'}</td>
                            <td style={{ ...tdStyle, textAlign: 'center' }}>
                              <span style={{
                                background: row.status === 'Pass' ? '#e6f7f2' : '#fef1eb',
                                color: row.status === 'Pass' ? '#067d62' : '#b12704',
                                padding: '2px 10px', borderRadius: 12, fontWeight: 700, fontSize: 12
                              }}>{row.status}</span>
                            </td>
                            <td style={tdStyle}>{row.date}</td>
                            <td style={tdStyle}>{row.time}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      ))
    )}
  </div>
</>
);
}
